module.exports = __webpack_public_path__ + "static/media/NimbusSanL-Bold.55b01b9a.woff2";